import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ActionButtons = ({ userInfo, onAcceptClick, onDenyClick }) => {
  const { t: translate } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleClick = async (type) => {
    setLoading(true);
    try {
      if (type === 'accept') {
        await onAcceptClick(userInfo);
      } else {
        await onDenyClick(userInfo);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', gap: '1em' }}>
      <ApproveButtnStyled
        className="d-flex align-items-center justify-content-center gap-1"
        onClick={() => handleClick('accept')}
        disabled={loading}
      >
        <i className="bx bx-check-circle" style={{ color: '#2B9E74' }} />
        <span style={{ color: '#2B9E74' }}>{translate('Accept')}</span>
      </ApproveButtnStyled>
      <DenyButtonStyled
        className="d-flex align-items-center justify-content-center gap-1"
        onClick={() => handleClick('deny')}
        disabled={loading}
      >
        <i className="bx bx-x-circle" style={{ color: '#A47B7B' }} />
        <span style={{ color: '#A47B7B' }}>{translate('Deny')}</span>
      </DenyButtonStyled>
    </div>
  );
};

const ApproveButtnStyled = styled(Button)`
  border: none;
  background-color: #c6eee0;

  :hover {
    background-color: #b2e0d4;
  }
  :disabled {
    background-color: #e0f5f2;
    cursor: not-allowed;
  }
`;

const DenyButtonStyled = styled(Button)`
  border: none;
  background-color: #fcd5d5;

  :hover {
    background-color: #f0b2b2;
  }
  :disabled {
    background-color: #f5e0e0;
    cursor: not-allowed;
  }
`;

ActionButtons.propTypes = {
  userInfo: PropTypes.object.isRequired,
  onAcceptClick: PropTypes.func.isRequired,
  onDenyClick: PropTypes.func.isRequired,
};

export default ActionButtons;
